<template>
  <div class="form-default">
    <header class="b-header">
      <h2 style="margin:0">Επιλέξτε ποια φωνήματα δεν λέει το παιδί σας</h2>
    </header>
    <main class="b-main" style="padding:0">
      <form v-on:submit.prevent="true">
        <div v-for="(question, row) in questions" v-bind:key="row" class="phonemes-sections">
          <p style="color:black">{{ question.subtitle }}</p>
          <br />
          <div>
            <div
              v-bind:id="row + '_' + index"
              v-for="(quest, index) in question.questions[0].text.split(',')"
              v-bind:key="index"
              v-on:click="checkPhoneme(row, index)"
              style="min-width:70px; margin-right:10px; margin-bottom:10px"
              class="phon-btn btn btn-outline-primary"
            >
              {{ quest }}
            </div>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
export default {
  name: 'FormPhonemes',
  data() {
    return {
      checkedPhonemes: []
    }
  },
  props: ['questions'],
  methods: {
    checkPhoneme: function($row, $index) {
      /**
     * TODO: DOCUMENT THIS
     * !SHOULD IMPROVE
     */
      const _this = this
      const iValue = $row + '_' + $index
      let removedValue = false

      _this.checkedPhonemes.forEach((item, index) => {
        if (item === iValue) {
          _this.checkedPhonemes.splice(index, 1)
          removedValue = true
        }
      })

      if (!removedValue) {
        _this.checkedPhonemes.push(iValue)
      }

      document.querySelectorAll('.phon-btn').forEach((el) => {
        el.classList.remove('btn-primary')
        el.classList.add('btn-outline-primary')
      })

      _this.checkedPhonemes.forEach((item, index) => {
        document.getElementById(item).classList.add('btn-primary')
        document.getElementById(item).classList.remove('btn-outline-primary')
      })

      _this.$parent.results = _this.checkedPhonemes
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.$parent.showBtn = true
    })
  }
}
</script>
